module.exports = __webpack_public_path__ + "static/media/features-2-first_section.e672907d.png";